import { wencesApi } from "@/api/wencesApi";

export const PAYMENT_COLLECT_RESPONSABLES_MODULE = "payment_collect_responsables_module";

export function isPaymentCollectResponsableModel(modelName) {
  const key = String(modelName || "").trim().toLowerCase();
  return key === "payment" || key === "collect";
}

export function shouldAssignResponsableFromRoute(route) {
  const flag = route?.query?.assign_responsable;
  if (flag == null || flag === "") return false;
  const normalized = String(flag).trim().toLowerCase();
  return normalized === "1" || normalized === "true" || normalized === "yes";
}

export async function assignResponsableViaApi(modelName, itemId) {
  const { data } = await wencesApi.post("/api/payment-collect-responsables/assign", {
    modelName,
    id: itemId,
  });
  if (!data?.success) {
    throw new Error(data?.error || "Assign responsable failed");
  }
  return data.data;
}

/**
 * One-shot vía eal: asigna responsable sin crear sesión.
 */
export async function assignResponsableViaEal(eal) {
  const { data } = await wencesApi.post(
    "/api/public/payment-collect-responsables/assign-by-eal",
    { eal }
  );
  if (!data?.success) {
    throw new Error(data?.error || "Assign responsable failed");
  }
  return data.data;
}

export function stripAssignResponsableQuery(route) {
  const query = { ...(route?.query || {}) };
  delete query.assign_responsable;
  return query;
}

export function stripAssignResponsableAndEalQuery(route) {
  const query = stripAssignResponsableQuery(route);
  delete query.eal;
  return query;
}

/** Captura el flag antes de redirects (p. ej. URL legible /i/…) que puedan perder el query. */
export function captureAssignResponsableIntent(route) {
  return shouldAssignResponsableFromRoute(route);
}
